module.exports = __webpack_public_path__ + "img/gods-of-jade-and-shadow.702d5cba.png";